import { cache } from 'swr';

import { useQuery } from 'service/utils';
import { Category, Product, ProductStockDataArgs } from 'service/types/generated';
import { QueryHookResponse, Override } from 'service/types/internal';
import ServiceConfigs from 'service/config';
import { storeCategoryQuery } from 'service/queries/products';

type useCategoryResponse = Override<Partial<Category>, { products: Array<Partial<Product>> }>;

type useCategoryType = ({
  categoryId,
  branchId,
  initialData,
  lang,
  scheduledTime,
}?: {
  categoryId: string;
  branchId?: string;
  initialData?: useCategoryResponse;
  lang?: string;
  scheduledTime?: ProductStockDataArgs['scheduledTime'];
}) => QueryHookResponse<useCategoryResponse>;

const useCategory: useCategoryType = ({ categoryId, branchId, initialData, scheduledTime, lang }) =>
  useQuery<useCategoryResponse>({
    query: storeCategoryQuery,
    variables: {
      subdomain: ServiceConfigs.getSubDomain(),
      uuid: categoryId,
      branchId,
      ...(scheduledTime && { scheduledTime }),
    },
    handler: (res: Record<string, Category>) => {
      const {
        category: { products, uuid, titleAr, titleEn, published },
      } = res || {};
      const returnedProducts = products?.map(product => {
        cache.set(product.uuid, product);
        return { uuid: product.uuid, quickAddToCart: product.quickAddToCart };
      });
      return { uuid, titleAr, titleEn, published, products: returnedProducts };
    },
    requestHeaders: lang ? { LANGUAGE: lang } : null,
    config: { initialData },
  });

export default useCategory;
